import { component } from 'picoapp';
import type { SwiperOptions } from 'swiper';
import { clear } from 'utils/node';

export default component((node: HTMLElement) => {
  const { productId, baseUrl: baseURL, limit } = node.dataset;

  const params = new URLSearchParams({
    section_id: node.id,
    product_id: productId,
    intent: 'related',
    limit,
  });

  const getRecommendations = async () => {
    const response = await fetch(`${baseURL}?${params.toString()}`);
    const text = await response.text();
    const html = new DOMParser().parseFromString(text, 'text/html');

    clear(node);
    node.insertAdjacentHTML('beforeend', html.querySelector('[data-component]').innerHTML);

    return html;
  };

  const initSlider = async (html: Document) => {
    const { default: Swiper, Scrollbar } = await import(/* webpackChunkName: "swiper" */ 'modules/swiper');
    const elementCount = html.querySelector('[data-slider] .swiper-wrapper').childElementCount;

    const slider: HTMLElement = node.querySelector('[data-slider]');
    const progressBar: HTMLElement = node.querySelector('[data-progress-bar]');

    const config: SwiperOptions = {
      modules: [Scrollbar],
      scrollbar: {
        el: progressBar,
        dragClass: 'product-slider__drag',
      },
      loop: false,
      slidesPerView: 2,
      spaceBetween: 15,
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
      },
    }

    if (elementCount > 6) {
      config.breakpoints[992].slidesOffsetBefore = window.innerWidth / 2;
      config.breakpoints[992].slidesOffsetAfter = window.innerWidth / 2;
    }

    // eslint-disable-next-line no-new
    new Swiper(slider, config);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        getRecommendations().then((html) => {
          initSlider(html);
          document.dispatchEvent(new Event('app:mount'));

          observer.unobserve(node);
        });
      }
    });
  });

  observer.observe(node);
});
